<div class="modal-header">
  <h4 class="modal-title">
    <ng-container *ngIf="data && !isCloning">
      Edit Product
    </ng-container>
    <ng-container *ngIf="!data && !isCloning">
      Create Product
    </ng-container>
    <ng-container *ngIf="data && isCloning">
      Clone Product
    </ng-container>
  </h4>
  <button type="button" class="btn-close focus:outline-none focus:shadow-none" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <i class="fas fa-times fa-1x"></i>
  </button>
</div>
<div class="modal-body">
  <div class="flex flex-row justify-between">
    <div class="basis-1/2">
      <div class="py-2">
        <span>Company Name</span>
        <dx-select-box
          #companySelectBox
          id="companySelectBox"
          displayExpr="Name"
          valueExpr="Id"
          [searchMode]="'contains'"
          [searchExpr]="'Name'"
          [searchTimeout]="200"
          [minSearchLength]="2"
          [searchEnabled]="true"
          [showDataBeforeSearch]="true"
          [acceptCustomValue]="true"
          [dataSource]="companyData"
          [value]="selectedEditCompany"
          (onSelectionChanged)="editCompanySelected($event)"
          (onCustomItemCreating)="addCustomCompanyItem($event)"
        ></dx-select-box>
      </div>
      <div class="py-2">
        <span>Master Brand</span>
        <dx-select-box
          #masterBrandSelectBox
          id="masterBrandSelectBox"
          displayExpr="Name"
          valueExpr="Id"
          [searchMode]="'contains'"
          [searchExpr]="'Name'"
          [searchTimeout]="200"
          [minSearchLength]="2"
          [searchEnabled]="true"
          [showDataBeforeSearch]="true"
          [items]="masterBrandData"
          [acceptCustomValue]="true"
          [value]="selectedEditMasterBrand"
          (onSelectionChanged)="onEditMasterBrandSelected($event)"
          (onCustomItemCreating)="addCustomMasterBrandItem($event)"
        ></dx-select-box>
      </div>
      <div class="py-2">
        <span>Brand</span>
        <dx-select-box
          #brandSelectBox
          id="brandSelectBox"
          displayExpr="Name"
          valueExpr="Id"
          [searchMode]="'contains'"
          [searchExpr]="'Name'"
          [searchTimeout]="200"
          [minSearchLength]="2"
          [searchEnabled]="true"
          [showDataBeforeSearch]="true"
          [items]="brandData"
          [value]="selectedEditBrand"
          [acceptCustomValue]="true"
          (onSelectionChanged)="onEditBrandSelected($event)"
          (onCustomItemCreating)="addCustomBrandItem($event)"
        ></dx-select-box>
      </div>
      <div class="py-2">
        <span>Sub-brand</span>
        <dx-select-box
          #subBrandSelectBox
          id="subBrandSelectBox"
          displayExpr="Name"
          valueExpr="Id"
          [searchMode]="'contains'"
          [searchExpr]="'Name'"
          [searchTimeout]="200"
          [minSearchLength]="2"
          [searchEnabled]="true"
          [showDataBeforeSearch]="true"
          [items]="subBrandData"
          [value]="selectedEditSubBrand"
          [acceptCustomValue]="true"
          (onSelectionChanged)="onEditSubBrandSelected($event)"
          (onCustomItemCreating)="addCustomSubBrandItem($event)"
        ></dx-select-box>
      </div>
    </div>
    <div class="basis-1/2">
      <div class="py-2">
        <span>Product</span>
        <dx-select-box
          #productSelectBox
          id="productSelectBox"
          displayExpr="Name"
          valueExpr="Id"
          [searchMode]="'contains'"
          [searchExpr]="'Name'"
          [searchTimeout]="200"
          [minSearchLength]="2"
          [searchEnabled]="true"
          [showDataBeforeSearch]="true"
          [dataSource]="productData"
          [value]="selectedEditProduct"
          [acceptCustomValue]="true"
          (onSelectionChanged)="onEditProductSelected($event)"
          (onCustomItemCreating)="addCustomProductItem($event)"
        ></dx-select-box>
      </div>
      <div class="flex justify-between py-2">
        <span>Nature Inspired</span>
        <dx-check-box [(value)]="productIsNatureInspired"></dx-check-box>
      </div>
      <div class="flex justify-between py-2">
        <span>Men's Product</span>
        <dx-check-box [(value)]="productIsMensProduct"></dx-check-box>
      </div>
      <div class="py-2">
        <span>Category</span>
        <dx-select-box
          displayExpr="Name"
          valueExpr="Id"
          searchMode="contains"
          [searchMode]="'contains'"
          [searchExpr]="'Name'"
          [searchTimeout]="200"
          [minSearchLength]="2"
          [searchEnabled]="true"
          [showDataBeforeSearch]="true"
          [items]="categoryData"
          [value]="selectedEditCategory"
          [searchEnabled]="true"
          (onValueChanged)="onEditCategorySelected($event)"
        ></dx-select-box>
      </div>
    </div>
    <div class="basis-1/2">
      <div class="py-2">
        <span>Function Subcategory</span>
        <dx-select-box
          displayExpr="Name"
          valueExpr="Id"
          searchMode="contains"
          [searchMode]="'contains'"
          [searchExpr]="'Name'"
          [searchTimeout]="200"
          [minSearchLength]="2"
          [searchEnabled]="true"
          [showDataBeforeSearch]="true"
          [items]="subcategoryFunctionData"
          [value]="selectedEditSubcategoryFunction"
          [searchEnabled]="true"
          (onValueChanged)="onEditSubcategoryFunctionSelected($event)"
        ></dx-select-box>
      </div>
      <div class="py-2">
        <span>Form Subcategory</span>
        <dx-select-box
          displayExpr="Name"
          valueExpr="Id"
          searchMode="contains"
          [searchMode]="'contains'"
          [searchExpr]="'Name'"
          [searchTimeout]="200"
          [minSearchLength]="2"
          [searchEnabled]="true"
          [showDataBeforeSearch]="true"
          [items]="subcategoryFormData"
          [value]="selectedEditSubcategoryForm"
          [searchEnabled]="true"
          (onValueChanged)="onEditSubcategoryFormSelected($event)"
        ></dx-select-box>
      </div>
      <div class="py-2">
        <span>Product Size - Volume</span>
        <dx-select-box
          displayExpr="ProductSizeByMetric"
          valueExpr="ProductSizeId"
          searchMode="contains"
          [searchMode]="'contains'"
          [searchExpr]="'ProductSizeByMetric'"
          [searchTimeout]="200"
          [minSearchLength]="2"
          [searchEnabled]="true"
          [showDataBeforeSearch]="true"
          [dataSource]="productSizeOnLabelData"
          [value]="selectedEditProductSizeOnLabel"
          [searchEnabled]="true"
          [acceptCustomValue]="true"
          (onSelectionChanged)="onProductSizeOnLabelSelected($event)"
          (onCustomItemCreating)="addCustomProductSizeOnLabelItem($event)">
        ></dx-select-box>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <dx-button
    icon="check"
    type="success"
    text="Save"
    (onClick)="saveProductMasterData()"
  >
  </dx-button>
  <dx-button
    icon="close"
    text="Cancel"
    (onClick)="activeModal.dismiss('Cross click')"
  >
  </dx-button>
</div>
